export default "__VITE_ASSET__3c996d6f__"